import store from 'Redux/store';
import { countryCode } from 'Helpers/Geo/Country';
import getEmailSubscribeStatus from 'Helpers/CRM/email-subscribe-status';

const LightboxUtils = {};

LightboxUtils.removeLightboxVars = () => {
  localStorage.removeItem('LIGHTBOX-email');
  localStorage.removeItem('LIGHTBOX-email_confirmed');
  localStorage.removeItem('LIGHTBOX-email_newsletter');
  localStorage.removeItem('LIGHTBOX-email_newsletter_status');
  localStorage.removeItem('LIGHTBOX-language');
  localStorage.removeItem('LIGHTBOX-country');
};

/**
 * Mirror the user's details into localStorage for the Cordial lightbox, which runs outside
 * React and cannot read the store.
 * @param {Object} authData The auth payload being dispatched. Callers run before their own
 *                          dispatch, so reading the store here would write the previous user's
 *                          details - or wipe them entirely on a fresh login, where the store
 *                          still holds the signed-out state. Falls back to the store for
 *                          callers that already have it applied
 */
LightboxUtils.setLightboxVars = (authData) => {
  const state = store.getState();
  const auth = authData || state.auth || {};
  const email = auth.email || '';
  if (email === '') {
    LightboxUtils.removeLightboxVars();
    return;
  }
  const emailConfirmed = auth.email_confirmed || false;

  const { isSubscribed, status } = getEmailSubscribeStatus(auth);
  const languageObject = state.language || {};
  const language = languageObject.from || 'en';
  const country = countryCode || 'GB';
  localStorage.setItem('LIGHTBOX-email', email);
  localStorage.setItem('LIGHTBOX-email_confirmed', emailConfirmed);
  localStorage.setItem('LIGHTBOX-email_newsletter', isSubscribed);
  localStorage.setItem('LIGHTBOX-email_newsletter_status', status);
  localStorage.setItem('LIGHTBOX-language', language);
  localStorage.setItem('LIGHTBOX-country', country);
};

LightboxUtils.getLightboxVars = () => {
  const email = localStorage.getItem('LIGHTBOX-email');
  const emailConfirmed = localStorage.getItem('LIGHTBOX-email_confirmed');
  const emailNewsletter = localStorage.getItem('LIGHTBOX-email_newsletter');
  const emailNewsletterStatus = localStorage.getItem('LIGHTBOX-email_newsletter_status');
  const language = localStorage.getItem('LIGHTBOX-language');
  const country = localStorage.getItem('LIGHTBOX-country');
  return {
    email,
    emailConfirmed,
    emailNewsletter,
    emailNewsletterStatus,
    language,
    country,
  };
};

export default LightboxUtils;
